import { getUserResponse } from './answer-helpers';
import cover1Src from '../assets/images/covers/cover-1.png';
import cover2Src from '../assets/images/covers/cover-2.png';
import cover3Src from '../assets/images/covers/cover-3.png';
import cover4Src from '../assets/images/covers/cover-4.png';
import cover5Src from '../assets/images/covers/cover-5.png';
import cover6Src from '../assets/images/covers/cover-6.png';
import cover7Src from '../assets/images/covers/cover-7.png';
import cover8Src from '../assets/images/covers/cover-8.png';
import cover9Src from '../assets/images/covers/cover-9.png';
import cover10Src from '../assets/images/covers/cover-10.png';
import cover11Src from '../assets/images/covers/cover-11.png';
import cover12Src from '../assets/images/covers/cover-12.png';
import cover13Src from '../assets/images/covers/cover-13.png';
import cover14Src from '../assets/images/covers/cover-14.png';
import cover15Src from '../assets/images/covers/cover-15.png';
import cover16Src from '../assets/images/covers/cover-16.png';
import cover17Src from '../assets/images/covers/cover-17.png';
import cover18Src from '../assets/images/covers/cover-18.png';

const BOOK_COVERS_BY_TITLE_ID = {
    1: cover1Src,
    2: cover2Src,
    3: cover3Src,
    4: cover4Src,
    5: cover5Src,
    6: cover6Src,
    7: cover7Src,
    8: cover8Src,
    9: cover9Src,
    10: cover10Src,
    11: cover11Src,
    12: cover12Src,
    13: cover13Src,
    14: cover14Src,
    15: cover15Src,
    16: cover16Src,
    17: cover17Src,
    18: cover18Src
};

function getBookCover(userResponses) {
    return BOOK_COVERS_BY_TITLE_ID[getUserResponse(userResponses, 9111)?.id] || BOOK_COVERS_BY_TITLE_ID[1];
}

export {
    getBookCover
};
